<template>
  <div class="lycra">
    <h2>
      Decoração em lycra
      <img src="@/assets/icons/spotlight.svg" alt="Ícone holofote" />
    </h2>

    <p>
      Fechamento e decoração de espaços criando um cenário diferente e
      modernizando seu evento, com ajuda das luzes cênicas transformamos seu
      espaço em um evento único!
    </p>

    <Carousel
      class="carousel"
      :class="{ fullscreen: isFullscreen }"
      v-slot="{ currentSlide }"
      htmlClass="slide-lycra"
    >
      <!-- Botão só aparece quando há slide ativo -->
      <img
        v-if="currentSlide"
        class="fullscreen-button"
        :src="
          isFullscreen
            ? require('@/assets/icons/fullscreen-exit.svg')
            : require('@/assets/icons/fullscreen.svg')
        "
        :alt="isFullscreen ? 'Sair do fullscreen' : 'Entrar em fullscreen'"
        role="button"
        tabindex="0"
        @click.stop="toggleFullscreen"
        @keyup.enter="toggleFullscreen"
      />

      <Slide v-for="slide in totalSlides" :key="slide" htmlClass="slide-lycra">
        <div
          v-show="currentSlide === slide"
          class="slide-info"
          @click="toggleFullscreen"
        >
          <img :src="images[slide - 1]" :alt="`Imagem lycra ${slide}`" />
        </div>
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { ref } from "vue";
import Carousel from "@/components/Carousel/Carousel.vue";
import Slide from "@/components/Carousel/Slide.vue";

export default {
  name: "Lycra",
  components: {
    Carousel,
    Slide,
  },
  setup() {
    const totalSlides = 9;
    const isFullscreen = ref(false);

    // Pré-carrega imagens uma única vez
    const images = Array.from({ length: totalSlides }, (_, i) => {
      const index = i + 1;
      try {
        return require(`@/img/lycra/${index}.jpg`);
      } catch {
        return require(`@/img/lycra/${index}.png`);
      }
    });

    const toggleFullscreen = () => {
      isFullscreen.value = !isFullscreen.value;
    };

    return {
      totalSlides,
      images,
      isFullscreen,
      toggleFullscreen,
    };
  },
};
</script>

<style lang="scss" scoped>
.lycra {
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  p {
    max-width: 900px;
    line-height: 150%;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
  }
}

.carousel {
  margin-bottom: 2rem;
  position: relative;
  background: #000000;
  cursor: pointer;

  .fullscreen-button {
    position: absolute;
    height: 30px;
    z-index: 1;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
  }
}

.fullscreen {
  border-radius: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100vh;
  width: 100vw;
  max-width: 100%;

  .slide-info {
    height: 100vh;
  }
}

.slide-info {
  position: absolute;
  width: 100%;
  height: 600px;

  img {
    border-radius: 0.75rem;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

@media (max-width: 900px) {
  .lycra p {
    margin: 0 1rem 1.5rem;
  }

  .carousel {
    margin-bottom: 0;
  }

  .slide-info img {
    border-radius: 0;
  }
}
</style>
